import { render } from "./PermissionMenu.vue?vue&type=template&id=0e641140&scoped=true"
import script from "./PermissionMenu.vue?vue&type=script&lang=js"
export * from "./PermissionMenu.vue?vue&type=script&lang=js"

import "./PermissionMenu.vue?vue&type=style&index=0&id=0e641140&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e641140"

export default script